module.exports = __webpack_public_path__ + "static/img/view-icon.88bd4d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/view-icon.png
// module id = 2id3
// module chunks = 0